import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { exhaustMap, map, catchError, of } from "rxjs";
import { DataService } from "src/app/services/data.service";
import { NotificationService } from "src/app/services/notification-service/notification.service";
import { getAllAuthenticationLog, getAllAuthenticationLogSuccess, getAllAuthenticationLogFailure } from "../actions/authentication-log.action";

@Injectable()
export class AuthenticationLogEffect {



  loadAuthenticationLogs$ = createEffect(() => this.actions$.pipe(
    ofType(getAllAuthenticationLog),
    exhaustMap(({ element, page, size }) => this.dataService.loadData(element, page, size).pipe(
      map((reponseDAO) => getAllAuthenticationLogSuccess(reponseDAO)),
      catchError((error) => of(getAllAuthenticationLogFailure({ error })))
    ))
  ))
  constructor(private actions$: Actions, private dataService: DataService) { }
}